<div class="custom-sidebar" [ngClass]="{'open': isSidebarOpen}">

  <mat-action-list>
    <button mat-list-item *ngFor="let menuItem of menuConfig" (click)="openPage(menuItem); toggleSideBar()"> {{'' + menuItem.key | translate}} </button>
  </mat-action-list>

</div>

<div class="side-nav-overlay" [ngClass]="{'open': isSidebarOpen}" (click)="toggleSideBar()"></div>

